export enum TMNotificationPriority {
  LOW = 0,
  NORMAL = 1,
  HIGH = 2,
  CRITICAL = 3,
};

export interface IBaseNotification {
  id: string;
  title: string;
  message: string;
  priority: TMNotificationPriority;
  type: TMNotificationType;
  createdAt?: string;
  readAt?: string;
  data?: unknown;
}

export enum TMNotificationType {
  AWARD = 'achievement',
  AWARD_INFO = 'achievement_info',
  SUBSCRIPTION = 'subscription',
}
